import AdContentSorting from '../react/AdContentSorting'

export default class PublicationJobsAdPlacements {
  constructor() {}

  index() {
    let list = new AdContentSorting({
      sortScope: '#sort-filters-ad-content',
      selector: '.js-ad-content-list',
      data: $('.js-react-data').data('ads'),
      roleType: this.role
    });
    list.render()
  }

  show() {
    N2.handle('click', '.js-archived-open-s3-url', (eve) => {
      $.each($(eve.currentTarget).data('urls'), (idx, url) => {
        window.open(url, "_blank")
      });
    })
  }
}
